import * as yup from 'yup'
import { isValidCpf, isValidCnpj } from '@brazilian-utils/validators'
import * as service from 'service'
import constants from './../../constants'

yup.addMethod(yup.string, 'cpf', function(args = {}) {
  const message = args.message || 'CPF inválido'

  return this.test('cpf', message, function(value) {
    const { path, createError } = this

    return !value || isValidCpf(value) || createError({ path, message })
  })
})

yup.addMethod(yup.string, 'cnpj', function(args = {}) {
  const message = args.message || 'CNPJ inválido'

  return this.test('cnpj', message, function(value) {
    const { path, createError } = this

    return !value || isValidCnpj(value) || createError({ path, message })
  })
})

yup.addMethod(yup.string, 'emailAvailable', function(args = {}) {
  const message = args.message || 'Email já está em uso'
  const currentEmail = args.currentEmail || null

  return this.test('emailAvailable', message, async function(value) {
    const { path, createError } = this
    const isCurrent = currentEmail === value

    if (isCurrent) {
      return true
    }

    try {
      await service.recurrence.customers.checkEmail({ email: value })

      return createError({ path, message })
    } catch (error) {
      if (error.response.status === 404) {
        return true
      }

      return createError({ path, message: 'Erro ao verificar email' })
    }
  })
})

yup.addMethod(yup.string, 'cpfAvailable', function(args = {}) {
  const message = args.message || 'CPF já está em uso'
  const currentCpf = args.currentCpf || null
  const kindRef = yup.ref(args.kind || 'kind')

  return this.test('cpfAvailable', message, async function(value) {
    const { path, createError, options } = this
    const isCurrent = currentCpf === value
    const kind =
      kindRef.getValue({ parent: options.parent }) || constants.people.PERSON

    if (isCurrent) {
      return true
    }

    try {
      await service.recurrence.customers.checkCpf({ cpf: value, kind })

      return createError({ path, message })
    } catch (error) {
      if (error.response.status === 404) {
        return true
      }

      return createError({ path, message: 'Erro ao verificar CPF' })
    }
  })
})

yup.addMethod(yup.string, 'cnpjAvailable', function(args = {}) {
  const message = args.message || 'CNPJ já está em uso'
  const currentCnpj = args.currentCnpj || null

  return this.test('cnpjAvailable', message, async function(value) {
    const { path, createError } = this
    const isCurrent = currentCnpj === value

    if (isCurrent) {
      return true
    }

    try {
      await service.recurrence.customers.checkCnpj({ cnpj: value })

      return createError({ path, message })
    } catch (error) {
      if (error.response.status === 404) {
        return true
      }

      return createError({ path, message: 'Erro ao verificar CNPJ' })
    }
  })
})
